import Online from './online';
import Deposits from './deposits';

export default {
    Online,
    Deposits
}